import React, { useState } from 'react'
import addToMailchimp from 'gatsby-plugin-mailchimp'
import { useStaticQuery, graphql } from 'gatsby'
import {
  Wrapper,
  SocialContainer,
  SocialIconsContainer,
  SocialLink,
  SocialText,
  LogoContainer,
  Logo,
  FooterLinks,
  FooterLink,
  FooterUpper,
  FooterBottom,
  ReservedRights,
  SubscribeContainer,
  SubmitContainer,
  ErrorField,
  SubscribeInput,
  SubscribeLabel,
  Feedback,
} from '../styles/Footer'
import { SubscribeButton } from './Buttons'
import { FooterV2 } from './Typography'
import FacebookIcon from '../static/FacebookIcon.svg'
import TwitterIcon from '../static/TwitterIcon.svg'
import InstagramIcon from '../static/InstagramIcon.svg'
import ZaatLogoSvg from '../static/ZaatLogo.svg'
import GitHubIcon from '../static/GitHub.svg'
import LinkedInIcon from '../static/LinkedIn.svg'

const Footer = () => {
  const [newsletterEmail, setNewsLetterEmail] = useState('')
  const [newsLetterResult, setNewsLetterResult] = useState('Subscribe')
  const [newsLetterError, setNewsLetterError] = useState(null)
  const data = useStaticQuery(graphql`
    query {
      allPortfolioJson {
        edges {
          node {
            id
            link
            title
          }
        }
      }
    }
  `)
  const projects = data.allPortfolioJson.edges
  const handleNewsletterSubmit = async e => {
    e.preventDefault()
    setNewsLetterResult('Sending...')
    const { result } = await addToMailchimp(newsletterEmail, { test: 'test' })

    setNewsLetterResult(result)
    setNewsLetterError(null)

    if (result === 'success') {
      setNewsLetterResult('Subscribed')
      setNewsLetterEmail('')

      setTimeout(() => {
        setNewsLetterResult('Subscribe')
      }, 2000)
    } else {
      setNewsLetterError('Oops! This Email is already exists!')
    }
  }

  return (
    <Wrapper>
      <FooterUpper>
        <LogoContainer>
          <Logo>
            <ZaatLogoSvg />
          </Logo>
          <SocialContainer>
            <SocialIconsContainer>
              <SocialLink target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/zaatdev" aria-label="facebook">
                <FacebookIcon />
              </SocialLink>
              <SocialLink target="_blank" rel="noopener noreferrer" href="https://twitter.com/zaatdev" aria-label="Twitter">
                <TwitterIcon />
              </SocialLink>
              <SocialLink target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/zaatdev/" aria-label="Instagram">
                <InstagramIcon />
              </SocialLink>
              <SocialLink target="_blank" rel="noopener noreferrer" href="https://github.com/zaatdev/" aria-label="github">
                <GitHubIcon />
              </SocialLink>
              <SocialLink target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/company/zaatdev/" aria-label="linkedin">
                <LinkedInIcon />
              </SocialLink>
            </SocialIconsContainer>
            <SocialText>@zaatdev</SocialText>
          </SocialContainer>
        </LogoContainer>

        <FooterLinks>
          <FooterV2>SITE MAP</FooterV2>
          <FooterLink href="/privacy/">Privacy Policy</FooterLink>
          <FooterLink href="/#contact/">Contact</FooterLink>
          <FooterLink href="/about/">About</FooterLink>
          <FooterLink href="/faq/">FAQ</FooterLink>
        </FooterLinks>
        <FooterLinks>
          <FooterV2>PORTFOILO</FooterV2>
          {projects.map(proj => (
            <FooterLink key={proj.node.id} target="_blank" href={proj.node.link}>
              {proj.node.title}
            </FooterLink>
          ))}
        </FooterLinks>
        <SocialContainer>
          <FooterV2>SUBSCRIBE</FooterV2>
          <SubscribeContainer>
            <SubscribeLabel htmlFor="newsletter">Subsribe to our newsletter to receive the latest news and offers</SubscribeLabel>
            <SubmitContainer onSubmit={handleNewsletterSubmit}>
              <SubscribeInput
                required
                type="email"
                name="newsletter"
                value={newsletterEmail}
                id="newsletter"
                autoComplete="off"
                placeholder="Please enter your email"
                onChange={e => setNewsLetterEmail(e.target.value)}
              />
              <SubscribeButton>{newsLetterResult !== 'error' ? newsLetterResult : 'SUBSCRIBE'}</SubscribeButton>
            </SubmitContainer>
            <ErrorField>{newsLetterError}</ErrorField>
          </SubscribeContainer>
        </SocialContainer>
      </FooterUpper>
      <FooterBottom>
        <Feedback rel="noreferrer" target="_blank" href="https://github.com/zaatdev/site-contents/issues/new">
          Something is wrong? Submit an issue on Github
        </Feedback>
        Copyright
        {`© ${new Date().getFullYear()}, `}
        <ReservedRights> Built by Zaat.Dev, All rights reserved.</ReservedRights>
      </FooterBottom>
    </Wrapper>
  )
}

export default Footer
